import type { SVGProps } from 'react';

export const Undo = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.95 18.5a.799.799 0 0 1-.55-.2.798.798 0 0 1-.2-.55.71.71 0 0 1 .2-.525.748.748 0 0 1 .55-.225h6.425c1.05 0 1.95-.342 2.7-1.025.75-.7 1.125-1.55 1.125-2.55 0-1.017-.375-1.867-1.125-2.55-.75-.7-1.65-1.05-2.7-1.05H7.35L9.625 12.1a.71.71 0 0 1 .2.525c0 .2-.067.375-.2.525a.748.748 0 0 1-.55.225.881.881 0 0 1-.525-.225L5.125 9.725c-.083-.1-.15-.2-.2-.3a1.03 1.03 0 0 1-.05-.325c0-.133.017-.25.05-.35.05-.1.117-.2.2-.3L8.55 5.025a.72.72 0 0 1 .525-.225c.217 0 .4.075.55.225a.8.8 0 0 1 .2.55.68.68 0 0 1-.2.5L7.35 8.325h7.025c1.467 0 2.717.492 3.75 1.475 1.05.983 1.575 2.192 1.575 3.625 0 1.417-.525 2.617-1.575 3.6-1.033.983-2.283 1.475-3.75 1.475H7.95Z" />
    </svg>
  );
};
